import { MenuItem } from '../models/menu/menu.model';

export const stdaeroMenu: MenuItem[] = [];
